import { render } from "./OrderNotesPage.vue?vue&type=template&id=3ab9141d&scoped=true"
import script from "./OrderNotesPage.vue?vue&type=script&lang=js"
export * from "./OrderNotesPage.vue?vue&type=script&lang=js"

import "./OrderNotesPage.vue?vue&type=style&index=0&id=3ab9141d&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab9141d"]])

export default __exports__